import { useEffect, useReducer } from 'react';
import { userInitState, userReducer } from 'features/user/reducer';
import userApi from 'api/user';
import authApi from 'api/auth';
import { USER } from 'features/user/actions';

export default function useCurrentUser () {
  const [state, dispatch] = useReducer(userReducer, userInitState);

  useEffect(() => {
    fetchCurrentUser();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCurrentUser = async () => {
    await userApi
      .getCurrentUser()
      .then(({ data }) => {
        if (Object.keys(data).length > 0) {
          const { attributes, ...rest } = data;
          cacheAuthorized();
          dispatch({
            type: USER.FETCH.SUCCESS,
            payload: {
              ...attributes,
              ...rest,
            },
          });
        } else {
          if(isGuest()) {
            loginGuest();
          }
        }
      })
      .catch(error => {
        dispatch({
          type: USER.FETCH.ERROR,
          payload: error,
        });
      });
  };

  const cacheAuthorized = () => sessionStorage.setItem('authorized', 'true');
  const cacheGuest = () => sessionStorage.setItem('isGuest', 'true');
  const clearCache = () => sessionStorage.clear();
  
  const isGuest = () => {
    return sessionStorage.getItem('isGuest');
  };

  const login = async () => {
    dispatch({ type: USER.LOGIN.SUCCESS, payload: { authorized: true} });
    cacheAuthorized();
    await fetchCurrentUser();
  };

  const loginGuest = async () => {
    dispatch({ type: USER.LOGIN.SUCCESS, payload: { guest: true} });
    cacheGuest();
  };

  const logout = () => {
    clearCache();
    authApi.logout().then(() => {
      // Because userProvider is outside of router is not possible to use useNavigate hook
      window.location.replace('/login');
    });
  };

  return {
    ...state,
    login,
    logout,
    loginGuest,
  };
}
